import { createContext, useCallback, useContext, useRef } from 'react';

const NavGuardContext = createContext({
  registerGuard: () => {},
  unregisterGuard: () => {},
  callGuard: () => false,
});

export const NavGuardProvider = ({ children }) => {
  const guardRef = useRef(null);

  const registerGuard = useCallback((guard) => {
    guardRef.current = guard;
  }, []);

  const unregisterGuard = useCallback(() => {
    guardRef.current = null;
  }, []);

  const callGuard = useCallback((proceed, cancel) => {
    if (guardRef.current) {
      guardRef.current(proceed, cancel);
      return true;
    }
    return false;
  }, []);

  return (
    <NavGuardContext.Provider value={{ registerGuard, unregisterGuard, callGuard }}>
      {children}
    </NavGuardContext.Provider>
  );
};

export const useNavGuard = () => useContext(NavGuardContext);

export default NavGuardContext;
